// frontend/src/theme.js
// Single source of truth for the application's look & feel.
// Tweak palette / typography / shape here and it propagates everywhere.

import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary:   { main: '#1e3a8a', light: '#3b82f6', dark: '#172554', contrastText: '#fff' }, // deep indigo-blue
    secondary: { main: '#0d9488', light: '#5eead4', dark: '#115e59', contrastText: '#fff' }, // teal accent
    success:   { main: '#16a34a', light: '#86efac', dark: '#14532d', contrastText: '#fff' },
    warning:   { main: '#d97706', light: '#fcd34d', dark: '#92400e', contrastText: '#fff' },
    error:     { main: '#dc2626', light: '#fca5a5', dark: '#7f1d1d', contrastText: '#fff' },
    info:      { main: '#0284c7', light: '#7dd3fc', dark: '#075985', contrastText: '#fff' },
    background: {
      default: '#f4f6fb',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#4b5563'
    },
    divider: 'rgba(15, 23, 42, 0.08)'
  },
  typography: {
    fontFamily: '"Inter","Segoe UI",Roboto,Helvetica,Arial,sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700, letterSpacing: '-0.02em' },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 }
  },
  shape: { borderRadius: 10 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'linear-gradient(90deg, #1e3a8a 0%, #1d4ed8 100%)',
          boxShadow: '0 2px 8px rgba(15,23,42,0.08)'
        }
      }
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 8, paddingInline: 14 },
        contained: { boxShadow: '0 1px 2px rgba(15,23,42,0.10)' }
      }
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 12 },
        outlined: { borderColor: 'rgba(15, 23, 42, 0.08)' }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04)'
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#f8fafc',
            color: '#334155',
            fontWeight: 700,
            textTransform: 'uppercase',
            fontSize: '0.72rem',
            letterSpacing: '0.04em'
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: 'rgba(15, 23, 42, 0.06)' }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500 }
      }
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined' }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0f172a',
          color: '#e2e8f0',
          borderRight: 'none'
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '2px 8px',
          '&.Mui-selected': {
            backgroundColor: 'rgba(59, 130, 246, 0.18)',
            color: '#fff',
            '& .MuiListItemIcon-root': { color: '#fff' }
          },
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.06)'
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: { color: 'rgba(226, 232, 240, 0.85)', minWidth: 40 }
      }
    }
  }
});

export default theme;
